type GetTourCalendarUrlParams = {
  listingAlias: string;
  tourId: string;
};

export default function getTourCalendarUrl({ listingAlias, tourId }: GetTourCalendarUrlParams): string {
  return `/rental-manager/properties/${encodeURIComponent(listingAlias)}/tours/tour-calendar?tourId=${encodeURIComponent(tourId)}`;
}
